import React, { useState } from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import { Link } from 'react-router-dom'
import Carousel from 'react-bootstrap/Carousel';
import { BiCheckShield } from "react-icons/bi";
import { IoTrendingUpSharp } from "react-icons/io5";
import { FaChevronRight, FaStar, FaUserAlt, FaWallet, FaRegBuilding } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";

import { BsFillCheckCircleFill, BsArrowRight } from "react-icons/bs";
import HowItWorksImg from './../Images/how-it-works.png';
import GalleryImg1 from './../Images/gal-1.png';
import GalleryImg2 from './../Images/gal-2.png';
import GalleryImg3 from './../Images/gal-3.png';
import GalleryImg4 from './../Images/gal-4.png';
import GalleryImg5 from './../Images/gal-5.png';
import Layout1 from './../Images/layout1.png';
import Accordion from 'react-bootstrap/Accordion';





function PropertyDetails() {
    const [showMore, setShowMore] = useState(false);
    const [showMore2, setShowMore2] = useState(false);
    const [showMore3, setShowMore3] = useState(false);
    return (
        <>
            <Header />
            <div className="banner w-100 mb-90" style={{ backgroundImage: `url(${HowItWorksImg})` }}>
                <div className="container">
                    <div className="banner-title text-center">
                        <h1>Property Details</h1>
                        <p><Link to="/">Home</Link> <span><FaChevronRight /></span> Property Details</p>
                    </div>
                </div>
            </div>


            {/* propert-details starts */}
            <div className="property-details pb-30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="gallery">
                                <div className="blur-bottom"></div>
                                <Carousel fade>

                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={GalleryImg1}
                                            alt="First slide"
                                        />

                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={GalleryImg2}
                                            alt="Second slide"
                                        />


                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={GalleryImg3}
                                            alt="Third slide"
                                        />


                                    </Carousel.Item>
                                </Carousel>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-6 mb-4">
                                    <div className="gal-img">
                                        <img src={GalleryImg2} alt="" />
                                    </div>
                                </div>
                                <div className="col-6 mb-4">
                                    <div className="gal-img">
                                        <img src={GalleryImg3} alt="" />
                                    </div>
                                </div>
                                <div className="col-6 mb-4">
                                    <div className="gal-img">
                                        <img src={GalleryImg4} alt="" />
                                    </div>
                                </div>
                                <div className="col-6 mb-4">
                                    <div className="gal-img">
                                        <img src={GalleryImg5} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="property-name property-title">
                            <h1>Property 4</h1>
                            <p><FiMapPin /> Agoda, surulere lagos</p>
                        </div>
                        <div className="property-reviews">
                            <div className="property-ratings mb-3">
                                <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* property details ends */}

            {/* general description starts */}

            <div className="top-border pt-60 mb-60">
                <div className="container">
                    <div className="gen-desc mb-30">
                        <h2>General Description</h2>
                    </div>
                    <div className="p-4 border-bx">
                        <div className="pb-4">
                            <div className="property-features d-flex justify-content-between p-2">
                                <div className="property-sub">
                                    <h6><FaWallet /> Rs 0</h6>
                                    <p>Min Investment</p>
                                </div>
                                <div className="property-sub">
                                    <h6><BiCheckShield /> 10%</h6>
                                    <p>Yeild</p>
                                </div>
                                <div className="property-sub">
                                    <h6><FaRegBuilding /> Commercial</h6>
                                    <p>Property Type</p>
                                </div>
                                <div className="property-sub">
                                    <h6><IoTrendingUpSharp /> 18%</h6>
                                    <p>Return Target</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* general description ends */}

            {/* overview starts */}
            <div className="overview mb-60">
                <div className="container">
                    <div className="gen-desc mb-30">
                        <h2>Overview</h2>
                    </div>
                    <div className="border-bx mb-4">
                        <div className="overview-header">

                            <div className=" row text-center px-4 py-3">
                                <div className="col-2">
                                    <div className="overview-head">
                                        <h4>Building</h4>
                                        <p>Property</p>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="overview-head">
                                        <h4>9609 SF</h4>
                                        <p>Total Area</p>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="overview-head">
                                        <h4>15 yr</h4>
                                        <p>Lease Period</p>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="overview-head">
                                        <h4>5 yr</h4>
                                        <p>Lock in period</p>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="overview-head">
                                        <h4>15%</h4>
                                        <p>Escalation</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="overview-txt p-4">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irur.
                                +see more</p>
                            <Link to="">+See More</Link>
                        </div>
                    </div>
                    <div className="overview-acc">
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Why Invest?</Accordion.Header>
                                <Accordion.Body>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                    minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                    culpa qui officia deserunt mollit anim id est laborum.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>

                </div>

            </div>

            {/* overview ends */}

            {/* property location starts */}
            <div className=" mb-60">
                <div className="container">
                    <div className="gen-desc mb-30">
                        <h2>Property Location</h2>
                    </div>
                    <div className="border-bx mb-4">

                        <div className="overview-txt p-4">
                            <p>This is an opportunity to invest in a brand new, Grade-A Office asset located in Mahadevpura, Bengaluru. The tenant is an international sportswear brand. Lease of 15 years and Lock-in period of 5 years. With high yields, long lease terms, excellent location, and a world class tenant. The asset makes for a compelling investment opportunity.</p>

                        </div>
                        <div className="property-map text-center pb-4">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d248744.24807710844!2d77.0308928!3d13.0592789!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670c9b44e6d%3A0xf8dfc3e8517e4fe0!2sBengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1667816177886!5m2!1sen!2sin" width="85%" height="250" style={{ border: '0' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>

            {/* property location ends */}

            {/* select layout starts */}
            <div className=" mb-60">
                <div className="container">
                    <div className="gen-desc mb-30">
                        <h2>Select Layout</h2>
                    </div>
                    <div className="row mb-30">
                        <div className="col-lg-4 mb-4">
                            <div className="layout-img mb-3">
                                <img src={Layout1} alt="" />
                            </div>
                            <div className="layout-title">
                                <h3>Layout 2</h3>
                                <p>This layout is  north faced lorem ispum</p>
                            </div>
                           
                            <div className="layout-btn">
                                <button className={showMore ? " selected-cls" : "select-cls"} onClick={() => setShowMore(!showMore)}>{showMore ? <BsFillCheckCircleFill /> : "Select"}{showMore ? " Selected" : ""} </button>
                                {/* <button className='selected-cls'><BsFillCheckCircleFill/> Selected</button> */}
                                {showMore ?
                                    <Link className='common-btn w-100' to="">Continue</Link>
                                    : ""}
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="layout-img mb-3">
                                <img src={Layout1} alt="" />
                            </div>
                            <div className="layout-title">
                                <h3>Layout 2</h3>
                                <p>This layout is  north faced lorem ispum</p>
                            </div>
                           
                            <div className="layout-btn">
                                <button className={showMore2 ? " selected-cls" : "select-cls"} onClick={() => setShowMore2(!showMore2)}>{showMore2 ? <BsFillCheckCircleFill /> : "Select"}{showMore2 ? " Selected" : ""} </button>
                                {/* <button className='selected-cls'><BsFillCheckCircleFill/> Selected</button> */}
                                {showMore2 ?
                                    <Link className='common-btn w-100' to="">Continue</Link>
                                    : ""}
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="layout-img mb-3">
                                <img src={Layout1} alt="" />
                            </div>
                            <div className="layout-title">
                                <h3>Layout 2</h3>
                                <p>This layout is  north faced lorem ispum</p>
                            </div>
                           
                            <div className="layout-btn">
                                <button className={showMore3 ? " selected-cls" : "select-cls"} onClick={() => setShowMore3(!showMore3)}>{showMore3 ? <BsFillCheckCircleFill /> : "Select"}{showMore3 ? " Selected" : ""} </button>
                                {/* <button className='selected-cls'><BsFillCheckCircleFill/> Selected</button> */}
                                {showMore3 ?
                                    <Link className='common-btn w-100' to="">Continue</Link>
                                    : ""}
                            </div>
                        </div>
                    </div>
                    <div class="view-more-layout text-center">
        
            <Link to="">View More Layout <BsArrowRight/></Link>
        
    </div>
                </div>
            </div>

            {/* select layout ends */}
            <Footer/>
        </>


    )
}

export default PropertyDetails